import { TODAY } from "@/data/mock";

export const MAINT_FREQ = { diaria: ["Diária", 1], semanal: ["Semanal", 7], quinzenal: ["Quinzenal", 15], mensal: ["Mensal", 30], trimestral: ["Trimestral", 90] };

export const M_STATUS = {
  em_dia: { label: "Em dia", tone: "green" },
  verificar: { label: "Verificar hoje", tone: "gold" },
  atrasada: { label: "Atrasada", tone: "red" },
  problema: { label: "Com problema", tone: "red" },
  nunca: { label: "Nunca verificado", tone: "dark" },
};

const addDays = (d, n) => {
  const x = new Date(`${d}T12:00:00`);
  x.setDate(x.getDate() + n);
  return x.toISOString().slice(0, 10);
};

export const nextCheck = (m) => (m.lastCheck ? addDays(m.lastCheck.date, MAINT_FREQ[m.frequency][1]) : TODAY);

export const maintStatus = (m) => {
  if (!m.lastCheck) return "nunca";
  if (m.lastCheck.status === "problema") return "problema";
  const next = nextCheck(m);
  return next > TODAY ? "em_dia" : next === TODAY ? "verificar" : "atrasada";
};

export const assigneeOf = (m, company) => m.assigneeId || company?.maintenanceResponsibleId || null;

export const companyMaintenance = (s, cid) => s.maintenance.filter((m) => m.companyId === cid);

export const maintRate = (s, cid) => {
  const list = companyMaintenance(s, cid);
  return list.length ? Math.round((list.filter((m) => ["em_dia", "verificar"].includes(maintStatus(m))).length / list.length) * 100) : 100;
};

export const myMaintenance = (s, collab) => {
  const company = s.companies.find((c) => c.id === collab.companyId);
  return companyMaintenance(s, collab.companyId).filter((m) => assigneeOf(m, company) === collab.id);
};
